import axios from "axios";
import * as notificationsTypes from "../../types/admin/notificationTypes";
import {
  messages,
  onMessageListener,
} from "../../../shared-components/push-notification";
import { notification } from "antd";
import { onMessage } from "firebase/messaging";
//Update Notifications
export const updateNotificatonAction =
  (formData) => async (dispatch, getState) => {
    try {
      dispatch({
        type: notificationsTypes.GET_NOTIFICATION_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/notification/update`,
        formData,
        config
      );

      dispatch({
        type: notificationsTypes.GET_NOTIFICATION_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: notificationsTypes.GET_NOTIFICATION_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//Update Notifications
export const updateAllByUserNotificatonAction =
  (formData) => async (dispatch, getState) => {
    try {
      dispatch({
        type: notificationsTypes.GET_NOTIFICATION_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/notification/all/update`,
        formData,
        config
      );

      dispatch({
        type: notificationsTypes.GET_NOTIFICATION_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: notificationsTypes.GET_NOTIFICATION_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//
export const markTicketNotificationsRead =
  (ticketId, company, token, user) => async (dispatch, getState) => {
    try {
      dispatch({ type: notificationsTypes.GET_NOTIFICATION_REQUEST });

      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const config = {
        headers: {
          Authorization: token ? token : sharedUserInfo?.payload?.token,
        },
      };
      let companyId;
      let userId;

      if (sharedUserInfo?.payload?.type === "admin") {
        companyId = sharedUserInfo?.payload?.company?._id;
        userId = sharedUserInfo?.payload?.id;
      } else if (sharedUserInfo?.empCompanies?.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
        userId = sharedUserInfo?.payload?.id;
      }

      const formData = {
        userId: user ? user : userId,
        notifyId: ticketId,
        markAsRead: true,
        support: true,
      };
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${
          company ? company : companyId
        }/notification/update`,
        formData,
        config
      );

      dispatch({
        type: notificationsTypes.GET_NOTIFICATION_SUCCESS,
        payload: data?.data,
      });
    } catch (err) {
      dispatch({
        type: notificationsTypes.GET_NOTIFICATION_FAIL,
        payload: err.message || "Network Error",
      });
    }
  };

//Get Notifications
export const getNotificatonAction =
  (company, token) => async (dispatch, getState) => {
    try {
      dispatch({
        type: notificationsTypes.GET_NOTIFICATION_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${token ? token : sharedUserInfo?.payload?.token}`,
        },
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.get(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${
          company ? company : companyId
        }/notification/`,
        config
      );
      dispatch({
        type: notificationsTypes.GET_NOTIFICATION_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      console.log(err);
      dispatch({
        type: notificationsTypes.GET_NOTIFICATION_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

// This action sets up Firebase listener and dispatches new notificationsexport const startFirebaseNotifications = () => (dispatch, getState) => {

export const startFirebaseNotifications = () => (dispatch, getState) => {
  const {
    sharedLogin: { sharedUserInfo },
  } = getState();

  onMessage(messages, (payload) => {
    let companyId;
    let userId;

    if (sharedUserInfo?.payload?.type === "admin") {
      companyId = sharedUserInfo?.payload?.company?._id;
      userId = sharedUserInfo?.payload?.id;
    } else if (sharedUserInfo?.empCompanies?.length > 0) {
      companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      userId = sharedUserInfo?.payload?.id;
    }

    const newNotification = {
      type: payload.data.type,
      id: payload.data.id,
      receiveTo: [{ userId, markAsRead: false }],
      title: payload.notification?.title,
      body: payload.notification?.body,
      notificationId: payload.data?.notificationId,
      createdAt: new Date().toISOString(),
    };

    dispatch({
      type: notificationsTypes.ADD_NOTIFICATION,
      payload: newNotification,
    });

    // notification.open({
    //   message: newNotification.title || "New Support Message",
    //   description: newNotification.body || "",
    //   placement: "topRight",
    //   duration: 5,
    //   style: {
    //     background: "rgba(255, 255, 255, 0.1)",
    //     backdropFilter: "blur(12px)",
    //     WebkitBackdropFilter: "blur(12px)",
    //     border: "1px solid rgba(255,255,255,0.2)",
    //     borderRadius: "12px",
    //     color: "#fff",
    //   },
    //   onClick: () => {
    //     document.querySelector("#support-widget-button")?.click();
    //   },
    // });
  });
};
